import { RouteObject } from 'react-router';

import { createBotsRoutes } from '../bots';

export function createToolsRoutes(): RouteObject[] {
  const botRoutes = createBotsRoutes();


  return [
    {
      path: '',
      async lazy() {
        const { ToolsEntry } = await import('./pages/toolsEntry/ToolsEntry');
        return { Component: ToolsEntry };
      }
    },
    {
      path: 'store-validation',
      async lazy() {
        const { StoreValidation } = await import('./storeValidation/StoreValidation');
        return { Component: StoreValidation };
      }
    },
    {
      path: 'scene-studio',
      async lazy() {
        const { SceneStudio } = await import('./sceneStudio/SceneStudio');
        return { Component: SceneStudio };
      }
    },
    {
      path: 'api-key-registration',
      async lazy() {
        const { ApiKeyRegistrationPage } = await import('./apiKeyRegistration/pages/ApiKeyRegistrationPage');
        return { Component: ApiKeyRegistrationPage };
      }
    },
    {
      path: 'oauth-configuration',
      async lazy() {
        const { OAuthConfigurationPage } = await import('./oAuthConfiguration/pages/OAuthConfigurationPage');
        return { Component: OAuthConfigurationPage };
      }
    },
    {
      path: 'entra-configuration',
      async lazy() {
        const { EntraSSOConfigurationPage } = await import('./entraConfiguration/pages/EntraSSOConfigurationPage');
        return { Component: EntraSSOConfigurationPage };
      }
    },
    {
      path: 'bots',
      children: botRoutes
    },
    {
      path: 'cards',
      async lazy() {
        const { AdaptiveCardPage } = await import('../adaptiveCards/pages/AdaptiveCardPage');
        return { Component: AdaptiveCardPage };
      },
    },
    {
      path: 'cards/:cardId/*',
      async lazy() {
        const { AdaptiveCardDetails } = await import('../adaptiveCards/pages/AdaptiveCardDetails');
        return { Component: AdaptiveCardDetails };
      },
    },
  ];
}
